import React from "react";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { useDeleteTimeRecord } from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function TimeRecordRemoval({ timeRecord, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, deleteTimeRecord } =
    useDeleteTimeRecord(timeRecord);

  return (
    <Modal
      header={t("timeRecordRemoval.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.text}>{t("timeRecordRemoval.message")}</p>
          <p className={styles.name}>
            {timeRecord.resource.name} — {timeRecord.task.name}
          </p>
          <p className={styles.text}>
            {DateTime.fromISO(timeRecord.recordingDate).toLocaleString(
              DateTime.DATE_SHORT,
            )}
          </p>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("timeRecordRemoval.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            press={() => deleteTimeRecord({ timeRecord })}
          >
            {t("timeRecordRemoval.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { TimeRecordRemoval };
